import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ArchiveBoxIcon, ArchiveBoxUpIcon } from '@rsos/assets/icons';
import {
  setResourcePanelView,
  useGetNorfolkSouthernRequestsQuery,
  useSelectedRequestId,
  useSetNorfolkSouthernQueueStateMutation,
} from '@rsos/reduxDataStore/src/features/resourceRequests';
import styles from '../ResourceRequestPanel/QueueCategoryToggleButton.module.css';
import { useResourceRequestClock } from '../useResourceRequestClock';
import { getNorfolkSouthernQueueCategory } from './norfolkSouthernStatusUtils';

/**
 * Header button that moves the open consist request to the Closed queue
 * section, or back to Active when it is already closed. Account-wide via
 * the digital dispatch queue state; renders nothing until the open request
 * is in the cache.
 */
export function NorfolkSouthernQueueStateToggleButton() {
  const dispatch = useDispatch();
  const selectedRequestId = useSelectedRequestId();
  const { data } = useGetNorfolkSouthernRequestsQuery();
  const nowMs = useResourceRequestClock();
  const [setQueueState] = useSetNorfolkSouthernQueueStateMutation();

  const request = data?.find(r => String(r.id) === selectedRequestId);

  const isClosed = request
    ? getNorfolkSouthernQueueCategory(request, nowMs) === 'closed'
    : false;

  const requestId = request?.id;
  const handleClick = useCallback(() => {
    if (requestId === undefined) {
      return;
    }
    setQueueState({
      requestId,
      state: isClosed ? 'open' : 'closed',
    });
    dispatch(setResourcePanelView('list_requests'));
  }, [requestId, isClosed, setQueueState, dispatch]);

  if (!request) {
    return null;
  }

  return (
    <button
      type="button"
      className={styles.toggleButton}
      onClick={handleClick}
      title={isClosed ? 'Move to Active queue' : 'Move to Closed queue'}
      aria-label={isClosed ? 'Move to Active queue' : 'Move to Closed queue'}
      data-name="norfolk-southern-queue-state-toggle"
    >
      {isClosed ? (
        <ArchiveBoxUpIcon width={12} height={12} />
      ) : (
        <ArchiveBoxIcon width={12} height={12} />
      )}
    </button>
  );
}
